export const TEXT_SEPARATOR = ' • '

export const TextSeparator = () => TEXT_SEPARATOR
